import React from 'react';
import programmeCommittee from '../data/programmeCommittee.json';

const ProgrammeCommittee = () => {
  return (
    <section id="programme-committee" className="programme-committee-section">
      <div className="container">
        <div className="section-header">
          <h2 className="display-4 fw-bold">
            <i className="fas fa-users-cog me-3"></i>Programme Committee
          </h2>
          {/* <p className="lead">The team behind the symposium</p> */}
        </div>

        <div className="row justify-content-center">
            <div className="col-lg-8">
                <div className="committee-list">
                {programmeCommittee.map((member, index) => (
                    <div key={index} className="committee-member">
                    <div className="member-role">
                        <h4>{member.role}</h4>
                    </div>
                    <div className="member-details">
                        <h3 className="member-name">{member.name}</h3>
                        <p className="member-position">{member.position}</p>
                    </div>
                    </div>
                ))}
                </div>
                <p className='text-center pt-4 mb-0'>& Members</p>
            </div>
        </div>
      </div>
    </section>
  );
};

export default ProgrammeCommittee;